import { createSlice } from '@reduxjs/toolkit';

const passwordHintSlice = createSlice({
  name: 'passwordHint',
  initialState: {
    hint: {},
    mailDomainList: {},
    isSuccess: false,
  },
  reducers: {
    getPwdHintList: () => {},
    getPwdHintListSuccess: (state, { payload }) => {
      state.hint = payload;
      state.isSuccess = false;
    },
    modifyPwdHintList: () => {},
    modifyPwdHintListSuccess: (state, { payload }) => {
      state.hint.mphoneNos = payload.mphoneNos;
      state.hint.xtnlEmailAddrs = payload.xtnlEmailAddrs;
      state.isSuccess = true;
    },
    getMailDomainList: () => {},
    getMailDomainListSuccess: (state, { payload }) => {
      state.mailDomainList = payload;
    },
    setIsSuccess: state => {
      state.isSuccess = false;
    },
  },
});

export const {
  getPwdHintList,
  getPwdHintListSuccess,
  modifyPwdHintList,
  modifyPwdHintListSuccess,
  getMailDomainList,
  getMailDomainListSuccess,
  setIsSuccess,
} = passwordHintSlice.actions;
export default passwordHintSlice.reducer;
